import '.fs{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.ft{padding-left:1.5rem;}.ssr-plugin'
import '.fu{margin:1rem 0;}.ssr-plugin'
import '.fv{color:var(--gray-700);}.ssr-plugin'
import '.fw{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="fs ft fu fv fw"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
